if (!customElements.get('ly-quote-banner')) {
    customElements.define('ly-quote-banner', class extends HTMLElement {

        data = {
            qaList: [],
            customer: {}
        }

        requestCache = {}

        async connectedCallback() {
            await customElements.whenDefined('ly-popover-v4')

            this.popper1 = this.querySelector('.ly-quote-banner-popover1')
            this.popper2 = this.querySelector('.ly-quote-banner-popover2')

            this.form1 = this.popper1.bodyContent.querySelector('.ly-quote-banner-popover1-form')
            this.form2 = this.popper2.bodyContent.querySelector('.ly-quote-banner-popover2-form')

            this.submitBtn = this.form2.querySelector('button')
            this.errorMsg = this.form2.querySelector('.error-msg')

            this.form1.addEventListener('submit', this.handleSubmit1)
            this.form2.addEventListener('submit', this.handleSubmit2)
        }

        disConnectedCallback() {
            this.form1.removeEventListener('submit', this.handleSubmit1)
            this.form2.removeEventListener('submit', this.handleSubmit2)
        }

        handleSubmit1 = evt => {
            console.log('aaaaaaaaa')
            evt.preventDefault()
            const fd = new FormData(this.form1)

            const list = []

            for (const [key, value] of fd) {
                const o = {}
                o[key] = value
                list.push(o)
            }

            this.data.qaList = list

            this.popper1.close()
            requestAnimationFrame(this.popper2.open)
        }

        handleSubmit2 = async evt => {
            evt.preventDefault()
            const fd = new FormData(this.form2)

            for (const [key, value] of fd) {
                this.data.customer[key] = value
            }

            const cacheKey = JSON.stringify(this.data)

            try {
                this.submitBtn.disabled = true
                this.submitBtn.textContent = 'Waiting...'

                let requestPromise = this.requestCache[cacheKey]

                if (!requestPromise) {
                    requestPromise = API.requestQuote(this.data).catch(err => {
                        delete this.requestCache[cacheKey]
                        throw err
                    })

                    this.requestCache[cacheKey] = requestPromise

                    // 1秒后自动清理
                    setTimeout(() => {
                        delete this.requestCache[cacheKey]
                    }, 1000)
                }

                await requestPromise

                this.errorMsg.textContent = ''

                this.popper2.close()

                requestAnimationFrame(() => {
                    location.href = '/pages/thank-you-fp'
                })
            } catch (error) {
                this.errorMsg.textContent = 'Please enter valid information.'
                console.error(error)
            } finally {
                this.submitBtn.disabled = false
                this.submitBtn.textContent = 'GET QUOTE'
            }
        }
    })
}